import { Component } from '@angular/core';
import { DialogBaseViewComponent, SimpleDialogData } from '@sb/library/base';

@Component({
    selector: 'lib-dialog-iframe',
    templateUrl: './dialog-iframe.component.html',
    styleUrls: ['./dialog-iframe.component.scss']
})
export class DialogIFrameComponent extends DialogBaseViewComponent<SimpleDialogData> {
    override readonly dismissible: boolean = true;

    override PrimaryAction() {
        super.PrimaryAction();
        this.DismissAction();
    }

    get primaryButtonText(): string {
        return this.data.PrimaryButtonText ?? $localize`:@@CommonClose:Close`;
    }
}
